/**
 * @file BaseCard 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect} from 'react';
import './index.less';

function BaseCard({children, title, onClick, isConfig}) {

    return (
        <div className="card-container">
            <div
                role="button"
                tabIndex={-1}
                className="card-header gradient-text"
                data-content={title}
                onClick={onClick}
            >
                {title}
                {
                    isConfig && (
                        <span className="more-text">More</span>
                    )
                }
            </div>
            <div className="card-content">
                {children}
            </div>
        </div>
    );
}

export default BaseCard;
